import lamp1 from '../assets/products/lamp/lamp1.png';
import lamp2 from '../assets/products/lamp/lamp2.png';
import lamp3 from '../assets/products/lamp/lamp3.png';
import lamp4 from '../assets/products/lamp/lamp4.jpg';
import lamp5 from '../assets/products/lamp/lamp5.jpg';
import moon1 from '../assets/products/moon/moon1.png';
import moon2 from '../assets/products/moon/moon2.png';

export const lampImages = [lamp1, lamp2, lamp3, lamp4, lamp5];
export const moonImages = [moon1, moon2];

export const lampImg = lamp1;
export const moonImg = moon1;
